'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    messageBarTitleClassNames: function() {
        return messageBarTitleClassNames;
    },
    useMessageBarTitleStyles_unstable: function() {
        return useMessageBarTitleStyles_unstable;
    }
});
const _react = require("@griffel/react");
const messageBarTitleClassNames = {
    root: 'fui-MessageBarTitle'
};
/**
 * Styles for the root slot
 */ const useRootBaseStyles = /*#__PURE__*/ (0, _react.__resetStyles)("r168xkm9", null, [
    ".r168xkm9{font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase300);font-weight:var(--fontWeightSemibold);line-height:var(--lineHeightBase300);}",
    ".r168xkm9::after{content:\" \";}"
]);
const useMessageBarTitleStyles_unstable = (state)=>{
    'use no memo';
    const rootBaseStyles = useRootBaseStyles();
    state.root.className = (0, _react.mergeClasses)(messageBarTitleClassNames.root, rootBaseStyles, state.root.className);
    return state;
};
